<div class="full-width-image-container">
  <img src="../../assets/AdobeStock_3558442.jpeg" alt="Header Image">
</div>
<div class="top">
  <div>Do The <span>Right Thing</span></div>
  <div>On Point <span>With Safety</span></div>
  <div>Roll up <span>Your Sleeves</span></div>
</div>
<br><br>

<div class="archive-container">
  <h2>Newsletter Archive</h2>
  <br>
    <div class="archive-list">
      @for (newsletter of newsletters; track newsletter.id) {
        <div class="archive-item">
          <app-news-item-card [newsItem]="newsletter" [compact]="true"></app-news-item-card>
        </div>
      }
    </div>
    </div>
